import React, { useEffect, useMemo } from 'react';
import { Amplify } from 'aws-amplify';
import awsexports from './aws-exports';
import '@aws-amplify/ui-react/styles.css';
import './faceLiveness.css';
import './documentUpload.css';
import './terceiraValida.css';
import './App.css';

import './modals/modais.css';

import { Routes, Route, useNavigate, useLocation } from "react-router-dom";

import { LivenessQuickStartReact } from './pages/prova-de-vida/LivenessQuickStartReact';
import { UploadDocumentReact } from './pages/upload-documento/UploadDocumentReact';
import { UploadComprovante } from './pages/upload-comprovante/UploadComprovante';
import { ValidaUrlReact } from './utils/ValidaUrlReact';
import { SucessoProcessoReact } from './pages/sucesso/SucessoProcessoReact';
import { ErroProcessoReact } from './pages/erro/ErroProcessoReact';
import { ValidaIdentidadePixReact } from './pages/validacao-pix/ValidaIdentidadePixReact';
import { LinkFinalizadoErro } from './pages/finalizado/LinkFinalizadoErro';
import { UploadDocsIDD } from './pages/upload-idd-documentos/UploadDocumentsIDD';
import { AtdDocumentViewer } from './pages/documentos-viewer/AtdDocumentViewer';
import { Status } from './pages/status/status.js';
import { Versao } from './pages/vesao/versao.js';
import IdentityConfirmationPage from './pages/confirmacao/confirmacao.tsx';
// import HeaderServico from './components/HeaderServico.tsx';
// import FooterCondicional from './components/footer.tsx';

Amplify.configure(awsexports);

function App() {

  const location = useLocation();
  const navigate = useNavigate();

  const ambiente = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return (params.get("ambiente") || (sessionStorage.getItem('ambienteOrigem') || "")).toLowerCase();
  }, []);

  useEffect(() => {
    const allowed = new Set(["walletz", "hml", "prod", "alprev", "totemalprev", "transfelegal"]);
    const env = allowed.has(ambiente) ? ambiente : "";

    document.documentElement.setAttribute("data-env", env);
  }, [ambiente]);

  useEffect( () => {
    async function validarSessao() {
      const session = sessionStorage.getItem('sessionToken');
      const hash = sessionStorage.getItem('sessionHash');

      try {
        const res = await fetch(
          `${process.env.REACT_APP_URL_API}/conform/session`,
          {
            method: 'GET',
            headers: {
              'x-Hash': hash,
              'x-Token': session,
              'x-Versao': '2.1.0'
            }
          }
        );

        const data = await res.json();
        const dados = data.retorno[0];

        if(data.erros === false){
          sessionStorage.setItem('dadosLinkAtual', JSON.stringify(dados))
          window.clarity("identify", dados.outProtocolo+'_'+dados.outLkcId);
          window.clarity("set", "sessionId", dados.outProtocolo);
          window.clarity("set", "linkId", dados.outLkcId);
          window.clarity("set", "fluxo", "liveness");
          window.clarity("set", "versao_app", "2.1.0");
          window.clarity("set", "aplicacao", sessionStorage.getItem('ambienteOrigem') || 'externo');
          window.clarity("set", "servico", dados.outServico);
          window.clarity("set", "user", dados.outDocumento);
        }
        else if(data.retorno === 'Versao invalida.'){
          navigate('/versao');
        }
        else{
          navigate('/status');
        }
      } catch (e) {
        console.error('Erro ao validar sessão', e);
      }
    }

    if(sessionStorage.getItem('sessionToken') && sessionStorage.getItem('sessionHash') && !["/", "/finalizado", "/sucesso", "/status", "/versao"].includes(location.pathname)){
      validarSessao();
    }
  }, [navigate, location]);

  // const hideChromeRoutes = ["/atd-document", "/document", "/confirmacao", "/face", "/validaid", "comprovante-residencia", "/documentos-idd"];
  // const hideChrome = hideChromeRoutes.includes(location.pathname);

  return (
    
    <>
      {/* {hideChrome && <HeaderServico />} */}
      <Routes>
        <Route path="/" element={<ValidaUrlReact />} />
        <Route path="/document" element={<UploadDocumentReact />} />
        <Route path="/face" element={<LivenessQuickStartReact />} />
        <Route path="/sucesso" element={<SucessoProcessoReact />} />
        <Route path="/erro" element={<ErroProcessoReact />} />
        <Route path="/finalizado" element={<LinkFinalizadoErro />} />
        <Route path="/status" element={<Status />} />
        <Route path="/versao" element={<Versao />} />
        <Route path="/validaid" element={<ValidaIdentidadePixReact />} />
        <Route path="/comprovante-residencia" element={<UploadComprovante />} />
        <Route path="/documentos-idd" element={<UploadDocsIDD />} />
        <Route path="/atd-document" element={<AtdDocumentViewer />} />
        <Route path="/confirmacao" element={<IdentityConfirmationPage />} />
      </Routes>

      {/* {hideChrome && <FooterCondicional />} */}
    </>
  );
}

export default App;
